// Frontend-only superadmin allowlist for cross-organisation management.
//
// IMPORTANT: this gates the admin UI only. The backend does NOT enforce it —
// any authenticated user can still call /organisations and /users directly.
// Real authorisation requires server-side work in varna-server.
export const SUPERADMIN_EMAILS = ["ara.nourbakhsh@gmail.com"];

export const isSuperAdminEmail = (email) =>
  typeof email === "string" &&
  SUPERADMIN_EMAILS.includes(email.trim().toLowerCase());
